// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3NjIU","requiredAsterisk":"Info_requiredAsterisk__25J0Y"};